/**
 * Enviar brand. The symbol (arrow + signal waves) sits on a solid chip
 * `bg-accent` with `text-accent-foreground` to be legible in any theme
 * (portfolio logo-theme-safe pattern), avoiding loose `text-accent`. The
 * wordmark uses the display typeface (Space Grotesk) for an energetic character.
 */

import type { Component } from "solid-js";
import { cn } from "@/lib/cn";
import { SendMark } from "@/components/brand/send-mark";

interface WordmarkProps {
  class?: string;
  /** Hides the text and leaves only the symbol (for compact headers). */
  iconOnly?: boolean;
}

export const Wordmark: Component<WordmarkProps> = (props) => (
  <div class={cn("inline-flex items-center gap-2.5", props.class)}>
    <span class="inline-flex h-9 w-9 items-center justify-center rounded-[var(--radius-lg)] bg-accent text-accent-foreground shadow-md shadow-accent/25">
      <SendMark class="h-[1.15rem] w-[1.15rem]" />
    </span>
    {!props.iconOnly && (
      <span class="font-display text-[1.35rem] leading-none text-foreground">Enviar</span>
    )}
  </div>
);
